import { Directive } from '@angular/core';
import { BrnSheetDescription } from '@spartan-ng/brain/sheet';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
    host: { 'data-slot': 'sheet-description' },
    hostDirectives: [BrnSheetDescription],
    selector: '[hlmSheetDescription]',
})
export class HlmSheetDescription {
    constructor() {
        classes(() => 'text-muted-foreground text-sm');
    }
}
